import { ClientApplicationField } from './client-application-field';

/** An clientApp is specific to each client and is the set of fields they want in their clientApp */
export class ClientApplication {
    id: string;
    clientId: string;
    fields: ClientApplicationField[];

    constructor(body: any) {
        this.id = body.id;
        this.clientId = body.clientId;

        this.fields = body.fields.map(
            (f: any) => new ClientApplicationField(f),
        );
    }
}
